var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOval00A = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 80 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M50 16c7.732 0 14 6.268 14 14s-6.268 14-14 14H30c-7.732 0-14-6.268-14-14s6.268-14 14-14h20Z"
})));
SvgOval00A.viewBox = '0 0 80 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgOval00A);
export default ForwardRef;